/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, ElementRef, Inject, Injector, Input, Optional, SkipSelf} from '@angular/core';
import {AbstractPopover} from '../common/abstract-popover';
import {Point} from '../common/popover';
import {POPOVER_HOST_ANCHOR} from '../common/popover-host-anchor.token';

const /** @type {?} */ POSITIONS: string[] = ["bottom-left", "bottom-right", "top-left", "top-right", "right", "left"];

const /** @type {?} */ SIZES: string[] = ["xs", "sm", "md", "lg"];
export class TooltipContent extends AbstractPopover {
/**
 * @param {?} injector
 * @param {?} parentHost
 */
constructor(injector: Injector,   parentHost: ElementRef) {
        if (!parentHost) {
            throw new Error("clr-tooltip-content should only be used inside of a clr-tooltip");
        }
        super(injector, parentHost);
        // Defaults
        this.position = "right";
        this.size = "sm";
    }
private _position: string;
/**
 * @return {?}
 */
get position() {
        return this._position;
    }
/**
 * @param {?} position
 * @return {?}
 */
set position(position: string) {
        // Ugh
        this.renderer.removeClass(this.el.nativeElement, "tooltip-" + this.position);
        if (position && (POSITIONS.indexOf(position) > -1)) {
            this._position = position;
        } else {
            this._position = "right";
        }
        // Ugh
        this.renderer.addClass(this.el.nativeElement, "tooltip-" + this.position);

        // set the popover values based on direction
        switch (position) {
            case ("top-right"):
                this.anchorPoint = Point.TOP_CENTER;
                this.popoverPoint = Point.LEFT_BOTTOM;
                break;
            case ("top-left"):
                this.anchorPoint = Point.TOP_CENTER;
                this.popoverPoint = Point.RIGHT_BOTTOM;
                break;
            case ("bottom-right"):
                this.anchorPoint = Point.BOTTOM_CENTER;
                this.popoverPoint = Point.LEFT_TOP;
                break;
            case ("bottom-left"):
                this.anchorPoint = Point.BOTTOM_CENTER;
                this.popoverPoint = Point.RIGHT_TOP;
                break;
            case ("right"):
                this.anchorPoint = Point.RIGHT_CENTER;
                this.popoverPoint = Point.LEFT_TOP;
                break;
            case ("left"):
                this.anchorPoint = Point.LEFT_CENTER;
                this.popoverPoint = Point.RIGHT_TOP;
                break;
            default:
                this.anchorPoint = Point.RIGHT_CENTER;
                this.popoverPoint = Point.LEFT_TOP;
                break;
        }
    }
private _size: string;
/**
 * @return {?}
 */
get size() {
        return this._size;
    }
/**
 * @param {?} size
 * @return {?}
 */
set size(size: string) {
        // Ugh
        this.renderer.removeClass(this.el.nativeElement, "tooltip-" + this.size);
        if (size && (SIZES.indexOf(size) > -1)) {
            this._size = size;
        } else {
            this._size = "sm";
        }
        // Ugh
        this.renderer.addClass(this.el.nativeElement, "tooltip-" + this.size);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-tooltip-content",
    template: `
        <ng-content></ng-content>
    `,
    host: {
        "[class.tooltip-content]": "true",
        // I'm giving up on animation, they did not work before and will not work now.
        // Too many conflicts with Clarity UI.
        "[style.opacity]": "1"
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: ElementRef, decorators: [{ type: Optional }, { type: Inject, args: [POPOVER_HOST_ANCHOR, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'position': [{ type: Input, args: ["clrPosition", ] },],
'size': [{ type: Input, args: ["clrSize", ] },],
};
}

function TooltipContent_tsickle_Closure_declarations() {
/** @type {?} */
TooltipContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TooltipContent.ctorParameters;
/** @type {?} */
TooltipContent.propDecorators;
/** @type {?} */
TooltipContent.prototype._position;
/** @type {?} */
TooltipContent.prototype._size;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
